var columnLabels,
  indexOf = [].indexOf;

columnLabels = {
  label: 'Membership name',
  category_id: 'Category',
  expiration_date: 'Expiration date',
  cost_repeat: 'Recurring cost',
  classes_limit: 'Privileges / Attendance limits',
  send_invoice_receipts: 'Send receipt emails',
  tax_status: 'Tax status',
  automatic_reschedule_days: 'Auto-reschedule settings',
  trial: 'Trial membership?',
  failure_fee_amount: 'Failure fees',
  event_type_ids: 'Restrict by Event Type',
  style_ids: 'Restrict by Style',
  allow_recurring_bookings: 'Allow recurring bookings',
  archived: 'Archived?',
  email_status: 'Email Status',
  sms_status: 'SMS Status',
  accept_booking_comms: 'Accepts Booking Comms?',
  accept_payment_sequence_comms: 'Accepts Payment Comms?',
  accept_general_sequence_comms: 'Accepts General Comms?',
  accept_user_triggered_comms: 'Accepts User-Triggered Comms?',
  add_makeup_classes_for_missed_classes: 'Missed class settings'
};

angular.module('gym.bulkUpdates').controller('BulkUpdateChangeColumnCtrl', ["$scope", "$rootScope", "$modal", "$modalInstance", "$http", "MembershipPlanCategories", "MembershipIntervalUnits", "MembershipPlans", "EventTypes", "GradingStyles", "isInteger", "bulkUpdate", "column", "categories", function($scope, $rootScope, $modal, $modalInstance, $http, MembershipPlanCategories, MembershipIntervalUnits, MembershipPlans, EventTypes, GradingStyles, isInteger, bulkUpdate, column, categories) {
  var automaticRescheduleFormReady, base, base1, eventStyleFormReady, eventTypeFormReady, failureFeeAmountFormReady, gym, isClassesIntervalValid, isClassesLimitFormValid, isClassesLimitValid, isFutureBookingCountLimitValid, isFutureBookingDateLimitValid;
  $scope.gym = gym = $rootScope.gym;
  $scope.currency = gym.currency_symbol;
  $scope.column = column;
  $scope.categories = categories;
  $scope.columnLabel = columnLabels[column];
  $scope.minDate = moment(gym.today).toDate();
  if (bulkUpdate.update_type === 'membership') {
    MembershipPlans.get('new').then(function(plan) {
      $scope.taxStatusOptions = plan.tax_status_options;
      return $scope.invoiceReceiptCcOptions = [[void 0, 'Disabled']].concat(plan.invoice_receipt_cc_options.map(function(item) {
        return [item, item];
      }));
    });
  }
  $scope.membership_interval_unit_pairs = _.pairs(MembershipIntervalUnits);
  $scope.params = angular.extend({}, bulkUpdate.column_changes);
  $scope.undoChangeAvailable = function() {
    return typeof bulkUpdate.column_changes[column] !== 'undefined';
  };
  if (column === 'classes_limit') {
    (base = $scope.params).classes_interval_unit || (base.classes_interval_unit = 'weeks');
    (base1 = $scope.params).future_booking_term_unit || (base1.future_booking_term_unit = 'weeks');
    if ($scope.undoChangeAvailable()) {
      $scope.params.not_classes_interval = !$scope.params.classes_interval_number;
    }
  }
  if (column === 'automatic_reschedule_days' && typeof $scope.params.automatic_reschedule_days !== 'undefined') {
    $scope.params.perform_automatic_reschedule = $scope.params.automatic_reschedule_days > 0;
  }
  if (column === 'failure_fee_amount' && typeof $scope.params.failure_fee_amount !== 'undefined') {
    $scope.params.failure_fee_enabled = $scope.params.failure_fee_amount > 0;
  }
  if (column === 'event_type_ids') {
    $scope.eventTypes = EventTypes.getList({
      count: 1000
    }).$object;
  }
  if (column === 'style_ids') {
    $scope.gradingStyles = GradingStyles.getList({
      count: 1000,
      slim: 1
    }).$object;
  }
  $scope.enabledOptions = [[true, 'Yes'], [false, 'No']];
  $scope.emailStatusOptions = [['email_accepted', 'Accepted'], ['email_not_accepted', 'Not Accepted']];
  $scope.smsStatusOptions = [['sms_accepted', 'Accepted'], ['sms_not_accepted', 'Not Accepted']];
  $scope.failureFeeInvoiceEmailOptions = [['use_membership_invoice_email_setting', 'Use membership setting'], ['skip_invoice_email_for_failure_fee', 'Invoice email disabled']];
  $scope.failureAutoRescheduleOptions = [['use_membership_auto_reschedule_setting', 'Use membership setting'], ['skip_auto_reschedule_for_failure_fee', 'Auto-reschedule disabled']];
  $scope.missedClassCalculationStrategyOptions = [['count_missed_classes_using_unbooked_events_only', 'Unbooked events'], ['count_missed_classes_using_unbooked_events_and_absent_bookings', 'Unbooked events, and/or unattended bookings']];
  $scope.missedClassReplacementStrategyOptions = [['generate_one_allowance_for_every_class_missed', 'Add one make-up class for each class missed'], ['generate_fixed_number_of_allowances_for_all_classes_missed', 'Add a fixed number of make-up classes']];
  $scope.displayFutureBookingLimitsDescription = function(event, type) {
    event.preventDefault();
    return $modal.open({
      template: require('templates/components/membership_plan/future_booking_limits.html.slim'),
      controller: 'FutureBookingLimitsModal',
      resolve: {
        type: function() {
          return type;
        }
      }
    });
  };
  $scope.onClassesLimitTypeChanged = function() {
    if ($scope.params.classes_unlimited) {
      $scope.params.classes_limit = 0;
      $scope.params.classes_interval_number = 0;
      return $scope.params.not_classes_interval = void 0;
    } else {
      $scope.params.future_bookings_count_limit = void 0;
      $scope.params.restrict_future_bookings_by_count = void 0;
      $scope.params.future_booking_term_number = void 0;
      return $scope.params.restrict_future_bookings_by_date = void 0;
    }
  };
  $scope.onClassesLimitChanged = function() {
    return $scope.params.classes_unlimited = false;
  };
  $scope.onPerformAutomaticRescheduleChange = function() {
    if ($scope.params.perform_automatic_reschedule) {
      return $scope.params.automatic_reschedule_days = void 0;
    } else {
      $scope.params.automatic_reschedule_days = 0;
      return $scope.params.automatic_reschedule_limit = void 0;
    }
  };
  $scope.onGenerateMissedClassesChange = function() {
    $scope.params.missed_class_threshold = void 0;
    $scope.params.total_makeup_class_limit_for_missed_classes = void 0;
    $scope.params.missed_class_replacement_fixed_number = void 0;
    $scope.params.missed_class_makeup_class_expiry_offset_number = void 0;
    $scope.params.missed_class_replacement_strategy = 'generate_one_allowance_for_every_class_missed';
    $scope.params.missed_class_calculation_strategy = 'count_missed_classes_using_unbooked_events_only';
    $scope.params.missed_class_makeup_class_expiry_offset_unit = 'days';
    if ($scope.params.add_makeup_classes_for_missed_classes) {
      return $scope.params.missed_class_threshold = 1;
    }
  };
  $scope.onMissedClassReplacementStrategyChange = function() {
    if ($scope.params.missed_class_replacement_strategy === 'generate_fixed_number_of_allowances_for_all_classes_missed') {
      return $scope.params.missed_class_replacement_fixed_number = 1;
    } else {
      return $scope.params.missed_class_replacement_fixed_number = void 0;
    }
  };
  $scope.onClassesIntervalChanged = function() {
    return $scope.params.classes_interval_number = 0;
  };
  $scope.onFailureFeeEnabledChange = function() {
    if (!$scope.params.failure_fee_enabled) {
      $scope.params.failure_fee_amount = 0;
      $scope.params.failure_fee_schedule_strategy = void 0;
      $scope.params.failure_fee_lead_days = void 0;
      $scope.params.failure_fee_invoice_email_status = void 0;
      return $scope.params.failure_fee_auto_reschedule_status = void 0;
    }
  };
  $scope.onRestrictAccessByEventTypeChange = function() {
    return $scope.params.event_type_ids = [];
  };
  $scope.onRestrictAccessByEventStyleChange = function() {
    return $scope.params.style_ids = [];
  };
  $scope.isTypeSelected = function(id) {
    return $scope.params.event_type_ids && indexOf.call($scope.params.event_type_ids, id) >= 0;
  };
  $scope.isStyleSelected = function(id) {
    return $scope.params.style_ids && indexOf.call($scope.params.style_ids, id) >= 0;
  };
  $scope.toggleType = function(id) {
    var base2;
    (base2 = $scope.params).event_type_ids || (base2.event_type_ids = []);
    if ($scope.isTypeSelected(id)) {
      return $scope.params.event_type_ids = _.without($scope.params.event_type_ids, id);
    } else {
      return $scope.params.event_type_ids.push(id);
    }
  };
  $scope.toggleStyle = function(id) {
    var base2;
    (base2 = $scope.params).style_ids || (base2.style_ids = []);
    if ($scope.isStyleSelected(id)) {
      return $scope.params.style_ids = _.without($scope.params.style_ids, id);
    } else {
      return $scope.params.style_ids.push(id);
    }
  };
  isClassesLimitValid = function() {
    var limit;
    limit = $scope.params.classes_limit;
    return (parseInt(limit, 10) >= 0 && isInteger(limit)) || $scope.params.classes_unlimited;
  };
  isClassesIntervalValid = function() {
    var interval;
    interval = $scope.params.classes_interval_number;
    return ((parseInt(interval, 10) >= 0 && isInteger(interval)) || $scope.params.not_classes_interval) && ($scope.params.classes_unlimited || typeof $scope.params.not_classes_interval !== 'undefined');
  };
  isFutureBookingCountLimitValid = function() {
    var limit;
    limit = $scope.params.future_bookings_count_limit;
    return (parseInt(limit, 10) >= 0 && isInteger(limit)) || !$scope.params.restrict_future_bookings_by_count;
  };
  isFutureBookingDateLimitValid = function() {
    var limit;
    limit = $scope.params.future_booking_term_number;
    return (parseInt(limit, 10) >= 0 && isInteger(limit)) || !$scope.params.restrict_future_bookings_by_date;
  };
  isClassesLimitFormValid = function() {
    return isClassesLimitValid() && isClassesIntervalValid() && isFutureBookingCountLimitValid() && isFutureBookingDateLimitValid() && $scope.allowRecurringBookingsFormValid();
  };
  automaticRescheduleFormReady = function() {
    var days, limit;
    days = $scope.params.automatic_reschedule_days;
    limit = $scope.params.automatic_reschedule_limit;
    return typeof $scope.params.perform_automatic_reschedule !== 'undefined' && (!$scope.params.perform_automatic_reschedule || (isInteger(days) && days > 0 && days <= 30) && (!limit || (isInteger(limit) && limit > 0 && limit <= 10)));
  };
  failureFeeAmountFormReady = function() {
    var days;
    days = $scope.params.failure_fee_lead_days;
    return typeof $scope.params.failure_fee_enabled !== 'undefined' && (!$scope.params.failure_fee_enabled || ($scope.params.failure_fee_amount >= 1 && $scope.params.failure_fee_schedule_strategy && (isInteger(days) && days > 0 && days <= 30) && $scope.params.failure_fee_invoice_email_status && $scope.params.failure_fee_auto_reschedule_status));
  };
  eventTypeFormReady = function() {
    var ref;
    return typeof $scope.params.restrict_access_by_event_type !== 'undefined' && (!$scope.params.restrict_access_by_event_type || ((ref = $scope.params.event_type_ids) != null ? ref.length : void 0) || $scope.params.book_events_with_no_event_type);
  };
  eventStyleFormReady = function() {
    var ref;
    return typeof $scope.params.restrict_access_by_style !== 'undefined' && (!$scope.params.restrict_access_by_style || ((ref = $scope.params.style_ids) != null ? ref.length : void 0) || $scope.params.book_events_with_no_style);
  };
  $scope.allowRecurringBookingsFormValid = function() {
    return typeof $scope.params.allow_recurring_bookings === 'undefined' || $scope.params.classes_unlimited || typeof $scope.params.classes_unlimited === 'undefined' || $scope.params.classes_interval_number;
  };
  $scope.undoChange = function() {
    switch (column) {
      case 'classes_limit':
        $scope.params.classes_limit = void 0;
        $scope.params.classes_unlimited = void 0;
        $scope.params.restrict_future_bookings_by_count = void 0;
        $scope.params.future_bookings_count_limit = void 0;
        $scope.params.restrict_future_bookings_by_date = void 0;
        $scope.params.future_booking_term_number = void 0;
        $scope.params.future_booking_term_unit = void 0;
        $scope.params.classes_interval_number = void 0;
        $scope.params.classes_interval_unit = void 0;
        break;
      case 'send_invoice_receipts':
        $scope.params.send_invoice_receipts = void 0;
        $scope.params.cc_invoice_receipts_to = void 0;
        break;
      case 'automatic_reschedule_days':
        $scope.params.perform_automatic_reschedule = void 0;
        $scope.params.automatic_reschedule_days = void 0;
        $scope.params.automatic_reschedule_limit = void 0;
        break;
      case 'failure_fee_amount':
        $scope.params.failure_fee_enabled = void 0;
        $scope.params.failure_fee_amount = void 0;
        $scope.params.failure_fee_schedule_strategy = void 0;
        $scope.params.failure_fee_lead_days = void 0;
        $scope.params.failure_fee_invoice_email_status = void 0;
        $scope.params.failure_fee_auto_reschedule_status = void 0;
        break;
      case 'event_type_ids':
        $scope.params.restrict_access_by_event_type = void 0;
        $scope.params.event_type_ids = void 0;
        $scope.params.book_events_with_no_event_type = void 0;
        break;
      case 'style_ids':
        $scope.params.restrict_access_by_style = void 0;
        $scope.params.style_ids = void 0;
        $scope.params.book_events_with_no_style = void 0;
        break;
      default:
        $scope.params[column] = void 0;
    }
    return $scope.update();
  };
  $scope.updateReady = function() {
    switch (column) {
      case 'classes_limit':
        return isClassesLimitFormValid();
      case 'send_invoice_receipts':
      case 'trial':
        return typeof $scope.params[column] !== 'undefined';
      case 'automatic_reschedule_days':
        return automaticRescheduleFormReady();
      case 'failure_fee_amount':
        return failureFeeAmountFormReady();
      case 'event_type_ids':
        return eventTypeFormReady();
      case 'style_ids':
        return eventStyleFormReady();
      case 'allow_recurring_bookings':
        return $scope.allowRecurringBookingsFormValid();
      case 'accept_booking_comms':
      case 'accept_payment_sequence_comms':
      case 'accept_general_sequence_comms':
      case 'accept_user_triggered_comms':
      case 'add_makeup_classes_for_missed_classes':
        return typeof $scope.params[column] !== 'undefined';
      default:
        return $scope.params[column];
    }
  };
  $scope.update = function() {
    var params, url;
    $scope.isLoading = true;
    url = `/gyms/${gym.id}/bulk_update/bulk_updates/${bulkUpdate.id}/set_column_changes`;
    params = {
      bulk_record_update: {
        column_changes: $scope.params
      }
    };
    params.bulk_record_update.column_changes.not_classes_interval = void 0;
    params.bulk_record_update.column_changes.perform_automatic_reschedule = void 0;
    params.bulk_record_update.column_changes.failure_fee_enabled = void 0;
    return $http.put(url, params).then(function() {
      return $modalInstance.close();
    }, function(response) {
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
